import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';
import Table from '@material-ui/core/Table';
import {
  Link,
  Paper,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  paper: {
    padding: 30
  },
  titleHeader: {
    fontSize: 18,
    fontWeight: 700
  },
  titleNoMenu: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 5,
    marginTop: 15
  },
  contentNoMenu: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '25.6px'
  },
  divWarning: {
    display: 'flex',
    alignItems: 'flex-end',
    border: '1px solid #FFEEEF',
    borderRadius: 4,
    backgroundColor: '#FFEEEF',
    padding: 8,
    margin: '10px 0',
    fontSize: '13.5px',
    lineHeight: '22.4px'
  },
  iconWarning: {
    color: '#FF545C',
    marginRight: 4
  }
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('page', 'setPage', 0)
);

const Main = enhance(
  ({
    classes,
    page,
    selectedPage,
    handleChangePage,
    totalCount,
    rowsPerPage,
    setRowsPerPage,
    menus,
    openTable,
    paramSubmitted
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    return (
      <>
        {paramSubmitted &&
        !paramSubmitted.shopId &&
        !paramSubmitted.shopName &&
        !paramSubmitted.menuId &&
        !paramSubmitted.menuName &&
        totalCount === 0 ? (
          <>
            {openTable && (
              <Paper className={classes.paper}>
                <div className={classes.titleHeader}>無料メニュー設定状況</div>
                <div>
                  <div className={classes.titleNoMenu}>
                    無料メニュー設定とは？
                  </div>
                  <div className={classes.contentNoMenu}>
                    店舗様が費用を負担する事で、お子様に無料でお食事券を提供できる機能です。
                    <br />
                    店舗様で支援金をご用意いただける場合、こどもごちめしのご利用画面に支援元としてロゴマークなどを表示できます。
                    <br />
                    利用可能数や提供期間を設定でき、GOCHIプラットフォーム上でご利用数の管理ができます。こどもごちめしの寄付額が不足し「利用可能数：０」の場合もご利用いただけるので、独自で支援イベントを開催したい場合などに有用です。
                    <div className={classes.divWarning}>
                      <ErrorOutlinedIcon className={classes.iconWarning} />
                      利用されたお食事代金は店舗様負担となり、振込はありませんのでご了承ください。
                    </div>
                    お問い合わせ窓口宛にご相談いただければ、設定方法についてご相談を承ります。
                    <br />
                    お問い合わせ窓口：
                    <br />
                    <Link
                      href="https://support.gigi.tokyo/contact/for-store/"
                      target="_blank"
                      className={classes.supportLink}
                    >
                      https://support.gigi.tokyo/contact/for-store/
                    </Link>
                  </div>
                </div>
              </Paper>
            )}
          </>
        ) : (
          <>
            {openTable && (
              <div>
                <ExPaginationGroup
                  count={
                    totalCount % rowsPerPage > 0
                      ? Math.floor(totalCount / rowsPerPage) + 1
                      : Math.floor(totalCount / rowsPerPage)
                  }
                  selectedPage={selectedPage}
                  handleChangePage={handleChangePage}
                  limit={rowsPerPage}
                  totalCount={totalCount}
                  setLimit={setRowsPerPage}
                  hideRowsPerPage
                />
                <div className={classes.scrollTable} id="scrollTableId">
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow className={classes.headerRow}>
                        <TableCell>店舗ID</TableCell>
                        <TableCell>店舗名</TableCell>
                        <TableCell>メニューID</TableCell>
                        <TableCell>メニュー名</TableCell>
                        <TableCell>
                          無料提供
                          <br />
                          開始日〜終了日
                        </TableCell>
                        <TableCell>食数（無料提供総数）</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {menus
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .filter(gochiMenu => gochiMenu.menuSettingDetailDto)
                        .map(gochiMenu => {
                          const key = `${gochiMenu.menuId}-${
                            gochiMenu.shopId
                          }-${gochiMenu.groupName}`;

                          return (
                            <TableRow key={key} hover>
                              <TableCell>{gochiMenu.shopId}</TableCell>
                              <TableCell>{gochiMenu.shopName}</TableCell>
                              <TableCell>{gochiMenu.menuId}</TableCell>
                              <TableCell>{gochiMenu.menuName}</TableCell>
                              <TableCell>
                                {gochiMenu.menuSettingDetailDto &&
                                  gochiMenu.menuSettingDetailDto
                                    .gochiKidFreeStartDate}
                                <span>〜</span>
                                {gochiMenu.menuSettingDetailDto &&
                                  gochiMenu.menuSettingDetailDto
                                    .gochiKidFreeEndDate}
                              </TableCell>
                              <TableCell>
                                {gochiMenu.menuSettingDetailDto &&
                                  gochiMenu.menuSettingDetailDto
                                    .gochiKidFreeSet}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && <></>}
                    </TableBody>
                  </Table>
                </div>
                <div>
                  <ExPaginationGroup
                    count={
                      totalCount % rowsPerPage > 0
                        ? Math.floor(totalCount / rowsPerPage) + 1
                        : Math.floor(totalCount / rowsPerPage)
                    }
                    selectedPage={selectedPage}
                    handleChangePage={handleChangePage}
                    limit={rowsPerPage}
                    totalCount={totalCount}
                    hideRowsPerPage
                  />
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
